export default __webpack_public_path__ + "images/5T.41751c2.png";